(ns frontend.view.grid.funds-grid.db
  (:require [frontend.db :as app-db]
            [reagent.core :as r]))

(defonce funds (r/cursor app-db/views [:funds]))
(defonce modal-state (r/cursor funds [:modals]))
(defonce grid-entities (r/cursor funds [:grid-entities]))
(defonce view-settings (r/cursor funds [:view-settings]))
(defonce fund-filters (r/cursor view-settings [:filters]))
(defonce selected-columns (r/cursor view-settings [:selected-columns]))
(defonce column-widths (r/cursor view-settings [:column-widths]))
(defonce ordered-columns (r/cursor view-settings [:ordered-columns]))

;;kanban related definitions
(defonce kanban (r/cursor funds [:kanban]))
(defonce expanded (r/cursor kanban [:expanded]))
(defonce grouped-by (r/cursor view-settings [:grouped-by]))
(defonce card-settings (r/cursor view-settings [:card-settings]))
(defonce lists (r/cursor kanban [:lists]))
(defonce sorted-kanban-entities (r/cursor funds [:sorted-kanban-entities]))

;;precalculated schema (for performance reasons):
(defonce schema (r/cursor funds [:schema]))
